module.exports = __webpack_public_path__ + "img/MarsBlack.3c0b69f2.png";